import { Box, Image } from '@chakra-ui/react';
import { CardPalette } from '../HistoryCard.types';

interface ConcertImageProps {
  imageLink: string;
  title?: string;
  palette: CardPalette;
}

export const ConcertImage = ({ imageLink, title, palette }: ConcertImageProps) => (
  <Box
    borderRadius={{ base: 'lg', md: 'xl' }}
    overflow='hidden'
    boxShadow={{
      base: '0 2px 4px rgba(0, 0, 0, 0.1)',
      md: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    }}
    border={{ base: '1px', md: '2px' }}
    borderStyle='solid'
    borderColor='dark.D100'
    position='relative'
    width='100%'
    maxW='356px'
    mx='auto'
    aspectRatio='1'
    _after={{
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      bgGradient: `linear(to-b, transparent 60%, ${palette.accentColor}20)`,
    }}
  >
    <Image src={imageLink} alt={title || 'Event'} width='100%' height='100%' objectFit='cover' />
  </Box>
);
